// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text, Stack, TextInput } from '@mantine/core';
import { i18n } from '@lingui/core';
import { useContext } from 'react';
import { DatePicker } from '@mantine/dates';
import { ContractContext } from '../../../Service/Context/ContractContextV2';

const ContractGeneralSection = () => {
  const { contract, savePatch } = useContext(ContractContext);
  const { date, number, label } = contract ?? {};

  return (
    <>
      <Text weight="bolder" size="lg" mt="sm" mb="md">
        Allgemein
      </Text>
      <Stack sx={{ maxWidth: 600 }}>
        <TextInput defaultValue={number} label="Nummer" onBlur={(e) => savePatch({ number: e.currentTarget.value })} />
        <DatePicker
          clearable={false}
          label={i18n._('contract.date')}
          value={date ? new Date(date) : null}
          placeholder="-"
          onChange={(val) => savePatch({ date: val })}
        />
        <TextInput
          defaultValue={label}
          label="Name (für Kunden sichtbar)"
          onBlur={(e) => savePatch({ label: e.currentTarget.value })}
        />
      </Stack>
    </>
  );
};

export default ContractGeneralSection;
